import React, { useState, useEffect, useMemo, useContext } from "react";
import { Container, Row, Col, Button } from "react-bootstrap";
import { formatDistanceToNow } from 'date-fns'
import { useParams } from 'react-router-dom';
import { es, enUS } from 'date-fns/locale';
import Screen from '../components/Screen';
import { UserContext } from "../context/user";
import { HotelContext } from "../context/hotel";
import { getCDNImage } from '../globals';
import { i18nValue } from '../functions';
import { T } from "react-translator-component";

const NotificationsDetail = () => {
  const { id } = useParams();
  const { notifications, notification, getNotification, markReadNotidication, language } = useContext(UserContext);
  const { sectionsByCode, getUrlPath } = useContext(HotelContext);
  const [ item, setItem ] = useState(null);
  const [ markReadInProgress, setMarkReadInProgress ] = useState(false);

  const createdAgo = useMemo(() => {
    if (!item) return '-';
    const _createdDate = Date.parse(item.createdAt);
    let _r = '-';
    try {
      _r = formatDistanceToNow(_createdDate, { addSuffix: true, locale: language === 'es' ? es : enUS });
    } catch (e) {
      console.error(e);
    }
    return _r;
  }, [item]);

  useEffect(() => {
    if (notifications) {
      const initialData = notifications.filter(i => i.id === id)[0];
      if (initialData?.id) {
        setItem({ ...initialData })
      }
    }
    if (id === notification?.id) {
      setItem(notification);
    } else {
      getNotification(id)
    }
  }, [id, notification])

  useEffect(() => {
    if (!item) return;
    if (item.unread && !markReadInProgress) {
      setMarkReadInProgress(true);
      markReadNotidication(item.id);
    }
  }, [item])

  if (!item || item.id !== id) {
    return <p>Loading...</p>
}

  return (
    <Screen
      section="notification"
      title={i18nValue(sectionsByCode['notifications'], 'title', language) || "Notifications"}
    >
      <div className="px-2">
        <small className="mb-3">{createdAgo}</small>
        <h4>{item.payload?.title || item.content?.title}</h4>
        {item.content?.photo && <img className="w-100 mb-3 mt-1" style={{ borderRadius: 10 }} src={getCDNImage(item.content.photo)} />}
        <Container
            className="card-generic mt-2"
            style={{
              borderColor: "#f3f3f3",
              borderWidth: 1,
              borderStyle: "solid",
            }}
          >
            <Row>
              <Col xs={12}>
                <p className="page-detail-description text-with-break-line mb-0" style={{ whiteSpace: "pre-wrap" }}>{item.payload?.message || item.content?.text}</p>
              </Col>
            </Row>
          </Container>
      </div>
      {item.content?.link && <div className="footer-container">
        <Row>
          <Col xs={12}>
            <Button
              size={'lg'}
              variant={'primary'}
              type={'button'}
              block={true}
              style={{ backgroundColor: "#348d38" }}
              // style={{ background: 'white', color: 'red' }}
              onClick={() => window.location.href = getUrlPath(item.content.link) }
            >
              {T(`notifications.link.${item.content.linkLabelI18nCode}`)}
            </Button>
          </Col>
        </Row>
      </div>}
    </Screen>
  );
}

export default NotificationsDetail;